<div class="modal-header">
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="fill-blue modal-img" [inlineSVG]="assets_path + 'assets/images/icons/edit.svg'"></div>
  <h2 class="w-100 text-center title-modal">Cadastro de novo atributo</h2>

  <p class="w-80 text-description">
    Após o cadastro do atributo não poderá ser editado.
  </p>

  <form [formGroup]="form" class="w-80 center-object">

    <mat-form-field class="w-100 mb-10" appearance="outline">
      <mat-label>Nome do atributo</mat-label>
      <input matInput type="text" placeholder="Digite o nome do atributo" formControlName="profileName"
        (change)="changeName($event)">
      <mat-error *ngIf="profileName.errors">
        <p class="error-message" *ngIf="profileName.errors?.required">Campo obrigatório</p>
        <p class="error-message" *ngIf="profileName.errors?.maxlength">
          O atributo precisa ter menos que 25 caracteres
        </p>
      </mat-error>
    </mat-form-field>

  </form>

  <p *ngIf="!isProfileValid" class="w-80 center-object text-red">
    Esse atributo já foi cadastrado, informe outro.
  </p>

  <div class="position-button">
    <button class="btn btn-purple-blue mx-4" (click)="close()">Cancelar</button>
    <button class="btn btn-green mx-4" [ngClass]="{'btn-op-gray': !form.valid}" type="submit"
      [disabled]="!form.valid || isSaveForm || !isProfileValid" (click)="submitForm()">Salvar</button>
  </div>
</div>
